export default class CustomerSourceManagementColumnModel {
	static CustomerSourceManagementColumn = [
	  {
		  title: 'Customer source',
		  align: 'left',
		  field: 'sourceName'
	  }
	]
}
